<template>
  <div>
    <MatchInfo></MatchInfo>
  </div>
</template>

<script>
import MatchInfo from "@/components/news/MatchInfo.vue";

export default {
  name: "MatchInfoView",
  components: {
    MatchInfo
  }
};
</script>

<style></style>
